<form [formGroup]="form" (ngSubmit)="onSubmit(form)">
  <div class="bolt-space-bottom-lg" id="splash-agency-channel">
    <bolt-select
      ngDefaultControl
      formControlName="agencyChannel"
      label="Agent affiliation"
      name="agentSelection"
      [attr.id]="'sfc-agency-channel'"
      required
      >
      <option value="IA">Independent agent</option>
      <option value="NSS">Nationwide agent</option>
    </bolt-select>
  </div>
  <bolt-button
    submit
    type="solid"
    size="lg"
    name="loginButton"
    [attr.id]="'spc-login-btn'"
    >Log in</bolt-button
    >
    @if (form.get('agencyChannel')?.value === 'IA') {
      <div class="helper-text">Need Help?
        <bolt-contextual-help>
          <p>For access, please contact your Nationwide Agent Center administrator</p>
        </bolt-contextual-help>
      </div>
    }
  </form>
